import decode from 'jwt-decode';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';

export default class AuthService {
    // Initializing important variables
    constructor(domain) {
        if (domain !== null && domain !== undefined) {
            this.domain = domain;
        } else {
            this.domain = process.env.REACT_APP_BACKEND_URL; // API server domain
        }
        this.fetch = this.fetch.bind(this);
        this.setUiMethods = this.setUiMethods.bind(this);
        // eslint-disable-next-line no-extend-native
        Date.prototype.toJSON = function () {
            return moment(this).format('YYYY-MM-DDTHH:mm:ssZ');
        };
        this.counter = 0;
        this.path = '';
        this.login = this.login.bind(this);
        this.getProfile = this.getProfile.bind(this);

    }

    setUiMethods(blockUi, unblockUi) {
        this.blockUi = blockUi;
        this.unblockUi = unblockUi;
    }

    fetch(url, options, headers) {
        const method = options !== undefined ? options.method : undefined;
        // performs api calls sending the required authentication headers
        if (headers === null || headers === undefined) {
            headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cahce',
            };
        }
        if (this.loggedIn()) {
            headers['Authorization'] = this.getToken();
        }
        if (method === 'POST' || method === 'PUT') {
            this.counter += 1;
            if (this.blockUi !== undefined) {
                this.blockUi();
            }
        }
        return new Promise((resolve, reject) => {
            fetch(url, {
                headers,
                ...options,
            })
                .then((response) => this.parseJSON(response, headers))
                .then((response) => {
                    if (method === 'POST' || method === 'PUT') {
                        this.counter -= 1;
                        if (this.counter <= 0 && this.unblockUi !== undefined) {
                            this.unblockUi();
                        }
                    }
                    if (
                        response.ok &&
                        (headers === undefined || headers.accept === 'application/json' || headers.Accept === 'application/json')
                    ) {
                        return resolve(response.json, response.status);
                    } else if (response.ok) {
                        return resolve(response.body);
                    }
                    // extract the error from the server's json
                    return reject(response.json);
                })
                .catch((error) => {
                    if (method === 'POST' || method === 'PUT') {
                        this.counter -= 1;
                        if (this.counter <= 0 && this.unblockUi !== undefined) {
                            this.unblockUi();
                        }
                    }
                    if (
                        error !== undefined &&
                        error !== null &&
                        error.message !== undefined &&
                        error.message !== null &&
                        (error.message.includes('NetworkError when attempting to fetch resource') ||
                            error.message.includes('Failed to fetch'))
                    ) {
                        error.message = 'komunikacji z serwerem podczas pobierania danych.';
                    }
                    reject(error);
                });
        });
    }

    parseJSON(response, headers) {
        if (response.status) {
            return new Promise((resolve, reject) => {
                if (headers === undefined || headers.accept === 'application/json' || headers.Accept === 'application/json') {
                    response.json().then(
                        (json) => {
                            resolve({
                                status: response.status,
                                ok: response.ok,
                                json,
                            });
                        },
                        (reason) => {
                            reject({
                                status: response.status,
                                ok: response.ok,
                                json: { message: reason },
                            });
                        }
                    );
                } else {
                    resolve({
                        status: response.status,
                        ok: response.ok,
                        body: response.body,
                    });
                }
            });
        } else {
            return new Promise((resolve) =>
                resolve({
                    status: response.status,
                    ok: response.ok,
                    json: { message: '' },
                })
            );
        }
    }

    login(username, password, selectedUserCbkId, selectedUserAgreementMapId, authCode) {
        let deviceUUID = this.generateDeviceUuid();
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/auth`, {
            method: 'POST',
            body: JSON.stringify({
                username: username.trim(),
                password,
                cbkId: selectedUserCbkId,
                userAgreementMapId: selectedUserAgreementMapId,
                deviceUUID,
                authCode: authCode,
            }),
        }).then((res) => {
            this.setToken(res.token);
            return Promise.resolve(res);
        });
    }

    acceptTerms(contractTermsId, token) {
        // Get a token from api server using the fetch api
        return this.fetch(
            `${this.domain}/account/accept-contract-terms`,
            {
                method: 'POST',
                body: JSON.stringify({
                    contractTermsId,
                }),
            },
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Pragma: 'no-cahce',
                Authorization: token,
            }
        ).then((res) => {
            this.setToken(res.token); // Setting the token in localStorage
            return Promise.resolve(res);
        });
    }

    refresh() {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/refresh`, {
            method: 'GET',
        }).then((res) => {
            this.setToken(res.token); // Setting the token in localStorage
            return Promise.resolve(res);
        });
    }
    switchCbk(selectedUserCbkId) {
        let token = this.getToken();
        return this.fetch(`${this.domain}/switchCbk`, {
            method: 'POST',
            body: JSON.stringify({
                token: token,
                cbkId: selectedUserCbkId,
            }),
        }).then((res) => {
            if (res !== undefined) {
                this.setToken(res.token); // Setting the token in localStorage
                return Promise.resolve(res);
            }
            else {
                this.persistErrorCbkMessage('error', '', 'Błąd podczas przełączenia kontrahenta');
            }
        })
            .catch((err) => {
                this.persistErrorCbkMessage('error', '', 'Błąd podczas przełączenia kontrahenta');
            });
    }


    logout() {
        // Get a token from api server using the fetch api
        this.fetch(`${this.domain}/user/logout`, {
            method: 'POST',
        })
            .then(() => { })
            .catch(() => { });
        sessionStorage.removeItem('id_token');
        sessionStorage.removeItem('i18nextLng');
    }

    loggedIn() {
        // Checks if there is a saved token and it's still valid
        const token = this.getToken(); // Getting token from localstorage
        const status = this.getProfile().helpDeskUser === true ? true : this.getProfile().loginStatus === 'ACTIVE';
        return !!token && !this.isTokenExpired(token) && status; // handwaiving here
    }

    isTokenValidForRefresh() {
        const token = this.getToken();
        try {
            const decoded = decode(token);
            let seconds = moment().diff(new Date(decoded.created), 'seconds');
            if (seconds > 30) {
                // Checking if token is expired. N
                return true;
            } else {
                return false;
            }
        } catch (err) {
            return false;
        }
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            if (decoded.exp < Date.now() / 1000) {
                // Checking if token is expired. N
                return true;
            } else return false;
        } catch (err) {
            return false;
        }
    }

    setToken(idToken) {
        // Saves user token to localStorage
        sessionStorage.setItem('id_token', idToken);
    }

    getToken() {
        // Retrieves the user token from localStorage
        const token = sessionStorage.getItem('id_token');
        if (token === 'null' || token === 'undefined') {
            return undefined;
        } else {
            return token;
        }
    }

    getDecodedToken(){
        return decode(this.getToken());
    }

    setTempToken(idToken) {
        // Saves user token to localStorage
        sessionStorage.setItem('temp_token', idToken);
    }

    getTempToken() {
        // Retrieves the user token from localStorage
        const token = sessionStorage.getItem('temp_token');
        if (token === 'null' || token === 'undefined') {
            return undefined;
        } else {
            return token;
        }
    }

    getProfile() {
        // Using jwt-decode npm package to decode the token
        if (!!this.getToken()) {
            try {
                const decoded = decode(this.getToken());
                return decoded;
            } catch (err) {
                console.log('getProfile', this.getToken(), err);
                return {};
            }
        } else {
            return {};
        }
    }
    getTempProfile() {
        // Using jwt-decode npm package to decode the token
        if (!!this.getTempToken()) {
            try {
                const decoded = decode(this.getTempToken());
                return decoded;
            } catch (err) {
                console.log('getProfile', this.getTempToken(), err);
                return {};
            }
        } else {
            return {};
        }
    }

    getRoles() {
        // Using jwt-decode npm package to decode the token
        try {
            const decoded = decode(this.getToken());
            let rolesArray = [];
            if (decoded !== undefined && decoded !== null && decoded.role !== undefined && decoded.role !== null) {
                decoded.role.forEach((element) => {
                    if (element.authority !== undefined && element.authority !== null) {
                        rolesArray.push(element.authority);
                    }
                });
            }
            return rolesArray;
        } catch (err) {
            return [];
        }
    }

    getRoles() {
        // Using jwt-decode npm package to decode the token
        try {
            const decoded = decode(this.getToken());
            let rolesArray = [];
            if (decoded !== undefined && decoded !== null && decoded.role !== undefined && decoded.role !== null) {
                decoded.role.forEach((element) => {
                    if (element.authority !== undefined && element.authority !== null) {
                        rolesArray.push(element.authority);
                    }
                });
            }
            return rolesArray;
        } catch (err) {
            return [];
        }
    }
    showSpotPrices() {
        // Using jwt-decode npm package to decode the token
        try {
            const decoded = decode(this.getToken());
            return decoded !== undefined && decoded !== null && decoded.agreementSapRole !== undefined && decoded.agreementSapRole !== null
            && (decoded.agreementSapRole==='HURT' || decoded.agreementSapRole==='FLOTA' || decoded.agreementSapRole==='FRANCZYZA' || decoded.agreementSapRole==='HURT EPT');
        } catch (err) {
            return false;
        }
    }

    getPermissions() {
        // Using jwt-decode npm package to decode the token
        try {
            const decoded = decode(this.getToken());
            let permissionsArray = [];
            if (decoded !== undefined && decoded !== null && decoded.permissions !== undefined && decoded.permissions !== null) {
                decoded.permissions.forEach((element) => {
                    if (element.authority !== undefined && element.authority != null) {
                        permissionsArray.push(element.authority);
                    }
                });
            }
            return permissionsArray;
        } catch (err) {
            return [];
        }
    }

    getProductAcceptedTerms() {
        try {
            const decoded = decode(this.getToken());
            let acceptedTermsArray = [];
            if (
                decoded !== undefined &&
                decoded !== null &&
                decoded.acceptedAgreementTermsList !== undefined &&
                decoded.acceptedAgreementTermsList !== null
            ) {
                decoded.acceptedAgreementTermsList.forEach((element) => {
                    acceptedTermsArray.push(element);
                });
            }
            return acceptedTermsArray;
        } catch (err) {
            return [];
        }
    }

    getHybridCardUserAcceptedTerms() {
        try {
            const decoded = decode(this.getToken());
            let acceptedTermsArray = [];
            if (
                decoded !== undefined &&
                decoded !== null &&
                decoded.acceptedHybridCardUserApprovalsList !== undefined &&
                decoded.acceptedHybridCardUserApprovalsList !== null
            ) {
                decoded.acceptedHybridCardUserApprovalsList.forEach((element) => {
                    acceptedTermsArray.push(element);
                });
            }
            return acceptedTermsArray;
        } catch (err) {
            return [];
        }
    }

    getHighwaysAcceptedTerms() {
        try {
            const decoded = decode(this.getToken());
            let acceptedTermsArray = [];
            if (
                decoded !== undefined &&
                decoded !== null &&
                decoded.acceptedHighwaysTermsList !== undefined &&
                decoded.acceptedHighwaysTermsList !== null
            ) {
                decoded.acceptedHighwaysTermsList.forEach((element) => {
                    acceptedTermsArray.push(element);
                });
            }
            return acceptedTermsArray;
        } catch (err) {
            return [];
        }
    }

    getAgreementSourceTypeFromToken() {
        try {
            const decoded = decode(this.getToken());
            let agrSource = undefined;
            if (
                decoded !== undefined &&
                decoded !== null &&
                decoded.agreementSourceType !== undefined &&
                decoded.agreementSourceType !== null
            ) {
                agrSource = decoded.agreementSourceType;
            };

            return agrSource;
        } catch (err) {
            return [];
        }
    }

    isProductAgreementTermAccepted(productAgreementTermId) {
        const productAgreementTerms = this.getProductAcceptedTerms();
        return productAgreementTerms.includes(productAgreementTermId);
    }

    isUserInRole(role) {
        const roles = this.getRoles();
        return roles.includes(role);
    }

    isUserInAnyRole(...rolesToFind) {
        const roles = this.getRoles();
        let authorized = false;
        rolesToFind.forEach((role) => {
            if (roles.includes(role)) {
                authorized = true;
            }
        });
        return authorized;
    }

    isUserInAnyRoleArray(rolesToFind) {
        const roles = this.getRoles();
        let authorized = false;
        rolesToFind.forEach((role) => {
            if (roles.includes(role)) {
                authorized = true;
            }
        });
        return authorized;
    }

    isUserHasPermission(permission) {
        const permissions = this.getPermissions();
        return permissions.includes(permission);
    }

    isUserHasAnyPermission(...permissionsToFind) {
        const permissions = this.getPermissions();
        let authorized = false;
        permissionsToFind.forEach((permission) => {
            if (permissions.includes(permission)) {
                authorized = true;
            }
        });
        return authorized;
    }

    isUserHasAnyPermissionArray(permissionsToFind) {
        const permissions = this.getPermissions();
        let authorized = false;
        permissionsToFind.forEach((permission) => {
            if (permissions.includes(permission)) {
                authorized = true;
            }
        });
        return authorized;
    }

    getUserId() {
        const user = this.getProfile();
        return user.userId ? user.userId : null;
    }
    getCbkId() {
        const user = this.getProfile();
        return user.cbkId ? user.cbkId : null;
    }

    expirationTimer() {
        try {
            const decoded = decode(this.getToken());
            let seconds = moment().diff(new Date(decoded.exp * 1000), 'seconds');
            return moment.utc(-seconds * 1000).format('mm:ss');
        } catch (err) {
            this.logout();
        }
    }

    persistErrorCbkMessage(severity, summary, detail) {
        this.saveCookie(
            'switchCbkError',
            JSON.stringify({
                severity, summary, detail
            })
        );
    }
    saveCookie(cookieName, cookieValue) {
        sessionStorage.setItem(cookieName, cookieValue);
    }
    saveCookieLocalStorage(cookieName, cookieValue) {
        localStorage.setItem(cookieName, cookieValue);
    }

    isHelpDeskUser() {
        let token = this.getToken() !== null ? this.getToken() : this.getTempToken() !== null ? this.getTempToken() : null;
        if (token !== null) {
            let user = this.getProfileFromToken(token);
            return user.helpDeskUser;
        }
        else return false;

    }

    getProfileFromToken(token) {
        // Using jwt-decode npm package to decode the token
        if (!!token) {
            try {
                const decoded = decode(token);
                return decoded;
            } catch (err) {
                console.log('getProfile form token');
                return {};
            }
        } else {
            return {};
        }
    }
    generateDeviceUuid() {
        let generatedDeviceUuid = "";
        let currentDeviceIdFromCookie = localStorage.getItem('trustedDeviceId');
        if (currentDeviceIdFromCookie !== null && currentDeviceIdFromCookie !== undefined) {
            generatedDeviceUuid = currentDeviceIdFromCookie;
        } else {
            generatedDeviceUuid = uuidv4() + Date.now().toString(16);
            this.saveCookieLocalStorage('trustedDeviceId', generatedDeviceUuid)
        }

        return generatedDeviceUuid;
    }
}
